import styled from 'styled-components'

export const NoteEditor = styled.div`
  animation: slideDown 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const EditorHeader = styled.div`
  margin-bottom: 10px;
`

export const EditorTitle = styled.h3`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 3px;
`

export const EditorHint = styled.p`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
`

export const EditorActions = styled.div`
  display: flex;
  gap: 6px;
  justify-content: flex-end;
  margin-top: 10px;
`
